<div id="chart-container" class="w-100 h-100">
  <div class="btn-div" *ngIf="isSeverity">
    <button
      class="btn overall-btn"
      (click)="showOverallData()"
      [ngClass]="{ active: isOverallActive }"
    >
      <span> Overall</span>
    </button>
    <select
      [ngClass]="{ active: !isOverallActive }"
      id="dropdown"
      [(ngModel)]="selectedTestSuite"
      class="custom-dropdown"
      (change)="onSelectionChange()"
    >
      <option value="" disabled selected>Test Suite</option>
      <option *ngFor="let option of testSuites" [value]="option">
        {{ option }}
      </option>
    </select>
  </div>
  
  <ng-container *ngIf="isLoading; else chartOrNoData">
    <div class="placeholder-glow">
      <div class="placeholder col-12" style="height: 200px;"></div>
    </div>
  </ng-container>

  <ng-template #chartOrNoData>
    <ng-container *ngIf="isDataValid(data); else noDataTemplate" [class]="name">
      <p-chart [type]="chartType" [data]="chartData" [options]="chartOptions"></p-chart>
    </ng-container>
  </ng-template>

  <ng-template #noDataTemplate>
    <app-no-data></app-no-data>
  </ng-template>
</div>
